module.exports = __webpack_public_path__ + "assets/img/know.b9409f2d.png";